import { __generator } from "tslib";
import { all, call, put, throttle } from 'redux-saga/effects';
import { request } from '../../xhr';
import { searchFailure, searchSuccess, searchTags } from './actions';
function apiSearch(query) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: '/tags/search',
                    params: {
                        query: query,
                    },
                }, function () { return ({
                    tags: [
                        { name: 'Obi-wan Kenobi' },
                        { name: 'Luke Skywalker' },
                        { name: 'Leia Organa' },
                    ].filter(function (_a) {
                        var name = _a.name;
                        return name.toLowerCase().includes(query.toLowerCase());
                    }),
                }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function handleSearchTags(action) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload.query) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, apiSearch(action.payload.query)];
            case 1:
                response = _a.sent();
                if (!(!response || response.error)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(searchFailure())];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(searchSuccess(response.tags.map(function (_a) {
                    var name = _a.name;
                    return name;
                })))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function tagInputSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([throttle(250, searchTags, handleSearchTags)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map